<template>
  <div>
    <aside v-bind:class="{'PC-sidebarTop': position == 'top'}">
      <div class="contenidoAside container container--estandar">
        <form @submit.prevent="" v-if="isOpen || position != 'top'">
          <p class="title " v-if="position != 'top'">Buscar tarifas</p>
          <div class="">
            <div class="col-11 p-3">
              <p class="subtitle mb-0">{{dataInfoReserva.title}}</p>
              <p class="notasInfoReserva mt-0">{{dataInfoReserva.hotelCity}}, {{dataInfoReserva.hotelCountry}}</p>
              <hr class="my-3">
              <p class="tituloInfo mb-2">{{$t('language.posadasCorporate.sidebarReserva.hHabitaciones')}}</p>
              <p class="parrafoInfo mb-2">{{dataInfoReserva.subTitle}}</p>
              <ul class="listIconModal">
                  <li class="row">
                      <i class="demo-icon icon-calendar col-1"></i>
                      <p class="col-10 mb-3 infoHabitacion">{{dataInfoReserva.arrivalDate}} - {{dataInfoReserva.departureDate}}<br>
                      <span class="notasInfoReserva">{{dataInfoReserva.nights}} {{dataInfoReserva.nights===1?$t('language.posadasCorporate.sidebarReserva.noche'):$t('language.posadasCorporate.sidebarReserva.noches')}}</span></p>
                  </li>
                  <li class="row">
                      <i class="demo-icon icon-bed col-1"></i>
                      <p class="col-10 mb-3 infoHabitacion">{{dataInfoReserva.totalRooms}} {{dataInfoReserva.totalRooms===1?$t('language.posadasCorporate.sidebarReserva.habitacion'):$t('language.posadasCorporate.sidebarReserva.habitaciones')}}<br>
                      <span class="notasInfoReserva">{{dataInfoReserva.rateType}}</span></p>
                  </li>
                  <li class="row">
                      <i class="demo-icon icon-user col-1"></i>
                      <p class="col-10 mb-3 infoHabitacion">{{dataInfoReserva.totalHuespedes}} {{dataInfoReserva.totalHuespedes===1?$t('language.posadasCorporate.sidebarReserva.huesped'):$t('language.posadasCorporate.sidebarReserva.huespedes')}}<br>
                      <span class="notasInfoReserva">{{dataInfoReserva.totalAdults}} {{dataInfoReserva.totalAdults===1?$t('language.posadasCorporate.sidebarReserva.adulto'):$t('language.posadasCorporate.sidebarReserva.adultos')}}{{dataInfoReserva.totalChildren===0?'':dataInfoReserva.totalChildren===1?', ' + dataInfoReserva.totalChildren + ' ' + $t('language.posadasCorporate.sidebarReserva.menor'): ', ' + dataInfoReserva.totalChildren + ' ' + $t('language.posadasCorporate.sidebarReserva.menores')}}{{dataInfoReserva.totalInfants===0?'':dataInfoReserva.totalInfants===1?', ' + dataInfoReserva.totalInfants + ' ' + $t('language.posadasCorporate.sidebarReserva.infante'): ', ' + dataInfoReserva.totalInfants + ' ' + $t('language.posadasCorporate.sidebarReserva.infantes')}}</span></p>
                  </li>
              </ul>
              <hr class="my-3">
              <div class="row">

                  <div class="col-6">
                      <p class="subtitle mb-0">{{$t('language.posadasCorporate.generals.totalEstanciaImpuestos')}} {{dataInfoReserva.nights}} {{dataInfoReserva.nights===1?$t('language.posadasCorporate.generals.noche'):$t('language.posadasCorporate.generals.noches')}}:</p>
                      <p class="notasInfoReserva mt-0">
                          {{dataInfoReserva.totalRooms}} {{dataInfoReserva.totalRooms===1?$t('language.posadasCorporate.sidebarReserva.habitacion'):$t('language.posadasCorporate.sidebarReserva.habitaciones')}}
                      </p>
                  </div>
                  <div class="col-6">
                      <br><br>
                      <p class="subtitle text-right mb-0">$ {{ ((infoCosto.data.userClientID===pyp||infoCosto.data.userClientID===pypsa||!showRates)&&infoCosto.data.tabActive===1?guiones:globalFunctions.numberFormat(dataInfoReserva.totalRateWithTaxes, 2, '.', ',')) }} <span class="moneda">{{dataInfoReserva.currencyCode}}</span></p>
                      <p class="text-right ver-detalleInfoReserva">
                          <a class="enlaceDetalle" @click.prevent="verDetalleR" onclick="return false;" href="#">{{$t('language.posadasCorporate.sidebarReserva.verDetalle')}}</a>
                      </p>
                  </div>
              </div>
            </div>
          </div>
          
        </form>
        <div class="row col-11" v-if="!isOpen && position == 'top'">
          <div class="col-6" v-show="!searchData.hotel">
            <p class="infoTotal"> {{$t('language.posadasCorporate.sidebarReserva.totalPagar')}}:</p> 
          </div>
          <div class="col-6" v-show="!searchData.hotel">
            <p class="infoTotalPrecio text-right">$ {{ ((infoCosto.data.userClientID===pyp||infoCosto.data.userClientID===pypsa||!showRates)&&infoCosto.data.tabActive===1?guiones:globalFunctions.numberFormat(dataInfoReserva.totalRateWithTaxes, 2, '.', ',')) }} <span class="infoTotalMoneda">{{dataInfoReserva.currencyCode}}</span></p>
          </div>
        </div>
        <button class="SidebarTop-toggleButton"
          v-bind:class="{'SidebarTop-toggleButton--open':isOpen}"
          @click="isOpen ? isOpen = false : isOpen = true">
          <span v-bind:class="[isOpen?'icon-up':'icon-navigate-down']" class="icon-navigate-down">
          </span>
        </button>
      </div>
    </aside>
    <DetalleCostos v-if="banDetCost" :key="componentKey" ></DetalleCostos>
  </div>
</template>

<script>
  import * as GlobalFunctions from "../../utils/GlobalFunctions";
  import DetalleCostos from './DetalleCostos';
  import SecureLS from 'secure-ls';


  export default {
    name: 'SidebarReservaTop',
    components: {
      DetalleCostos,
    },
    data() {
      return {
        pyp: 'PYP', //no cambiar este valor
        pypsa: 'PYPSA', //no cambiar este valor
        guiones: '-------', //no cambiar este valor
        showRates: null,
        plusDeChambres: 1,
        currentLocation: "",
        ls: new SecureLS({encodingType: 'aes'}),
        totalStayWithOptionalSupplements: 0,
        originalValue: 0,
        supplemnFinal: 0,
        totalTaxesDetail: 0,
        componentKey: 0,
        globalFunctions: GlobalFunctions,
        banDetCost: false,
        infoCosto: null,
        dataInfoReserva: {
          title: null,
          subTitle: null,
          arrivalDate: null,
          departureDate: null,
          currencyCode: null,
          nights: null,
          totalRooms: null,
          rateType: null,
          totalHuespedes: null,
          totalAdults: null,
          totalChildren: null,
          totalInfants: null,
          totalRateWithTaxes: null,
          hotelCountry: null,
          hotelCity: null
      },

        isOpen: false,
        searchData: this.searchdata || {
          hotel: '',
        },
      };
    },
    props: {
      position: String,
      searchdata: Object,
      infoReserva: Object
    },
    created() {
      var currentLocation = window.location;
            this.currentLocation = window.location
            if(currentLocation.pathname == "/reservaciones-metodos-pago" ) {
            var persistentData = this.$store.getters.getOptionalSupplements
                this.$store.commit('updateTotalStay', {optionalSupplementsObject: persistentData.optionalSupplementsObject})
            }
            this.showRates = this.ls.get('Profile').data.ratesPermissionsResponse.showRates;
            this.plusDeChambres = this.infoReserva.data.habitacion.totalRooms
      if (this.infoReserva.data.localStor === 'datosHabHotSelected') {
        //los dattos vienen del localstorage
        this.infoCosto = this.infoReserva;
        this.dataInfoReserva.title = this.infoReserva.data.hotelName;
        this.dataInfoReserva.subTitle = this.infoReserva.data.hotel.title;
        this.dataInfoReserva.arrivalDate = this.infoReserva.data.habitacion.beautiDateInput;
        this.dataInfoReserva.departureDate = this.infoReserva.data.habitacion.beautiDateOutput;
        this.dataInfoReserva.currencyCode = this.infoReserva.data.habitacion.currencyCode;
        this.dataInfoReserva.nights = this.infoReserva.data.hotel.nights;
        this.dataInfoReserva.totalRooms = this.infoReserva.data.habitacion.totalRooms;
        this.dataInfoReserva.rateType = this.infoReserva.data.hotel.negotiatedRatesDetailPrice.rateType;
        this.dataInfoReserva.totalHuespedes = (this.infoReserva.data.habitacion.totalAdults + this.infoReserva.data.habitacion.totalChildren + this.infoReserva.data.habitacion.totalInfants);
        this.dataInfoReserva.totalAdults = this.infoReserva.data.habitacion.totalAdults;
        this.dataInfoReserva.totalChildren = this.infoReserva.data.habitacion.totalChildren;
        this.dataInfoReserva.totalInfants = this.infoReserva.data.habitacion.totalInfants;
        this.dataInfoReserva.totalRateWithTaxes = this.infoReserva.data.hotel.negotiatedRatesDetailPrice.totalRateWithTaxes;
        this.dataInfoReserva.hotelCity = this.infoReserva.data.cityDir;
        this.dataInfoReserva.hotelCountry = this.infoReserva.data.countryDir;
        this.originalValue = this.infoReserva.data.hotel.negotiatedRatesDetailPrice.totalRateWithTaxes;
        this.supplemnFinal = this.dataInfoReserva.totalRateWithTaxes
      }
         if(this.$store.getters.getOptionalSupplements == null || this.$store.getters.getOptionalSupplements == undefined || this.$store.getters.getOptionalSupplements == '' || this.$store.getters.getOptionalSupplements.length == 0) {
        } else {
            if(this.$store.getters.getOptionalSupplements.optionalSupplementsObject === undefined || this.$store.getters.getOptionalSupplements.optionalSupplementsObject.length == 0) {
            this.dataInfoReserva.totalRateWithTaxes -= ( this.totalStayWithOptionalSupplements * this.plusDeChambres )
            this.supplemnFinal = this.dataInfoReserva.totalRateWithTaxes
            this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTotalRateWithTaxes = 0
            this.totalStayWithOptionalSupplements = 0
            this.totalTaxesDetail = 0
            } else {
            for(var i = 0; i <  this.$store.getters.getOptionalSupplements.optionalSupplementsObject.length; i++) {
            this.totalStayWithOptionalSupplements = this.$store.getters.getOptionalSupplements.optionalSupplementsObject[i].reqOpcional.amount
            for(var j = 0; j <  this.$store.getters.getOptionalSupplements.optionalSupplementsObject[i].reqOpcional.rateSupplementTaxesResponseList.length; j++) {
            this.totalStayWithOptionalSupplements += this.$store.getters.getOptionalSupplements.optionalSupplementsObject[i].reqOpcional.rateSupplementTaxesResponseList[j].taxAmount
            this.totalTaxesDetail += this.$store.getters.getOptionalSupplements.optionalSupplementsObject[i].reqOpcional.rateSupplementTaxesResponseList[j].taxAmount
            }
            }
             this.ls.set('moreStayingTaxes',  this.totalStayWithOptionalSupplements)
            this.dataInfoReserva.totalRateWithTaxes += ( this.totalStayWithOptionalSupplements * this.plusDeChambres )
            this.supplemnFinal = this.dataInfoReserva.totalRateWithTaxes
            this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTotalRateWithTaxes = this.totalStayWithOptionalSupplements
}
  }
    },
    computed: {
            optionalSupplements() {
                        return this.$store.getters.getOptionalSupplements
            },
    },
    watch: {
        optionalSupplements() {
                    this.dataInfoReserva.totalRateWithTaxes = this.originalValue
                    var extraSupE = 0
                    var extraSupIE = 0
                    var extraToSE = 0 
                    var extraSupEFirstNight = 0
                    var extraSupIEFirstNight = 0
                    var extraToSEFirstNight = 0 
                    var ob = {
                                extraSupE: extraSupE,
                                extraSupIE: extraSupIE,
                                extraToSE: extraToSE
                            }
                    var ob2 = {
                                extraSupE: extraSupEFirstNight,
                                extraSupIE: extraSupIEFirstNight,
                                extraToSE: extraToSEFirstNight
                            }
                            this.ls.set('supleCondiOneFirstNight', ob2)
                            this.ls.set('supleCondi', ob)
                    if(this.ls.get('nuitsPourS') != null && this.ls.get('nuitsPourS') != "") {
                        var numNuits = this.ls.get('nuitsPourS')
                    } else {
                        var numNuits = 1
                    }
                    var suplObject = (this.$store.getters.getOptionalSupplements.optionalSupplementsObject==undefined||this.$store.getters.getOptionalSupplements.optionalSupplementsObject==null?[]:this.$store.getters.getOptionalSupplements.optionalSupplementsObject)
                    for(var i=0; i < suplObject.length; i++) {
                    switch(suplObject[i].reqOpcional.quantityType) {
                        case 5:
                    extraSupE += suplObject[i].reqOpcional.amount / numNuits
                    for(var j = 0; j < suplObject[i].reqOpcional.rateSupplementTaxesResponseList.length; j++) {
                        if(suplObject[i].reqOpcional.rateSupplementTaxesResponseList[j].taxCode == "IVA") {
                            extraSupIE += suplObject[i].reqOpcional.rateSupplementTaxesResponseList[j].taxAmount / numNuits
                        }
                    }
                    extraToSE += (extraSupIE + extraSupE)
                    var obje = {
                        extraSupE: extraSupE,
                        extraSupIE: extraSupIE,
                        extraToSE: extraToSE
                    }
                    this.ls.set('supleCondi', obje)
                    break;
                case 3:
                    extraSupE += suplObject[i].reqOpcional.amount / numNuits
                    for(var j = 0; j < suplObject[i].reqOpcional.rateSupplementTaxesResponseList.length; j++) {
                        if(suplObject[i].reqOpcional.rateSupplementTaxesResponseList[j].taxCode == "IVA") {
                            extraSupIE += suplObject[i].reqOpcional.rateSupplementTaxesResponseList[j].taxAmount / numNuits
                        }
                    }
                    extraToSE += (extraSupIE + extraSupE)
                    var obje = {
                        extraSupE: extraSupE,
                        extraSupIE: extraSupIE,
                        extraToSE: extraToSE
                    }
                    this.ls.set('supleCondi', obje)
                    break;
                case 8:   
                    extraSupE += suplObject[i].reqOpcional.amount / numNuits
                    for(var j = 0; j < suplObject[i].reqOpcional.rateSupplementTaxesResponseList.length; j++) {
                        if(suplObject[i].reqOpcional.rateSupplementTaxesResponseList[j].taxCode == "IVA") {
                            extraSupIE += suplObject[i].reqOpcional.rateSupplementTaxesResponseList[j].taxAmount / numNuits
                        }
                    }
                    extraToSE += (extraSupIE + extraSupE)
                    var obje = {
                        extraSupE: extraSupE,
                        extraSupIE: extraSupIE,
                        extraToSE: extraToSE
                    }
                    this.ls.set('supleCondi', obje)
                    break;
                case 1:  case 7:     
                        extraSupE += suplObject[i].reqOpcional.amount / numNuits
                        for(var j = 0; j < suplObject[i].reqOpcional.rateSupplementTaxesResponseList.length; j++) {
                            if(suplObject[i].reqOpcional.rateSupplementTaxesResponseList[j].taxCode == "IVA") {
                                extraSupIE += suplObject[i].reqOpcional.rateSupplementTaxesResponseList[j].taxAmount / numNuits
                            }
                        }
                        extraToSE += (extraSupIE + extraSupE)
                        var obje = {
                            extraSupE: extraSupE,
                            extraSupIE: extraSupIE,
                            extraToSE: extraToSE
                        }
                        this.ls.set('supleCondi', obje)
                        break;
                        case 2: case 6:
        extraSupEFirstNight += suplObject[i].reqOpcional.amount 
        for(var j = 0; j < suplObject[i].reqOpcional.rateSupplementTaxesResponseList.length; j++) {
            if(suplObject[i].reqOpcional.rateSupplementTaxesResponseList[j].taxCode == "IVA") {
                extraSupIEFirstNight += suplObject[i].reqOpcional.rateSupplementTaxesResponseList[j].taxAmount 
            }
        }
        extraToSEFirstNight += (extraSupIEFirstNight + extraSupEFirstNight)
        var obje = {
            extraSupE: extraSupEFirstNight,
            extraSupIE: extraSupIEFirstNight,
            extraToSE: extraToSEFirstNight
        }
        this.ls.set('supleCondiOneFirstNight', obje)
            break;
        case 4:
                 extraSupEFirstNight += suplObject[i].reqOpcional.amount 
        for(var j = 0; j < suplObject[i].reqOpcional.rateSupplementTaxesResponseList.length; j++) {
            if(suplObject[i].reqOpcional.rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                extraSupIEFirstNight += suplObject[i].reqOpcional.rateSupplementTaxesResponseList[j].taxAmount 
            }
        }
        extraToSEFirstNight += (extraSupIEFirstNight + extraSupEFirstNight)
        var obje = {
            extraSupE: extraSupEFirstNight,
            extraSupIE: extraSupIEFirstNight,
            extraToSE: extraToSEFirstNight
        }
        this.ls.set('supleCondiOneFirstNight', obje)
            break;
    default:
        break;
} 
}
this.totalStayWithOptionalSupplements = 0
this.totalTaxesDetail = 0
if(this.$store.getters.getOptionalSupplements.optionalSupplementsObject == null || this.$store.getters.getOptionalSupplements.optionalSupplementsObject.length == 0) {
this.dataInfoReserva.totalRateWithTaxes = this.originalValue
this.supplemnFinal = this.dataInfoReserva.totalRateWithTaxes
this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTotalRateWithTaxes = 0
this.totalStayWithOptionalSupplements = 0
this.totalTaxesDetail = 0
} else {
for(var i = 0; i <  this.$store.getters.getOptionalSupplements.optionalSupplementsObject.length; i++) {
this.totalStayWithOptionalSupplements += this.$store.getters.getOptionalSupplements.optionalSupplementsObject[i].reqOpcional.amount
for(var j = 0; j <  this.$store.getters.getOptionalSupplements.optionalSupplementsObject[i].reqOpcional.rateSupplementTaxesResponseList.length; j++) {
 this.totalStayWithOptionalSupplements += this.$store.getters.getOptionalSupplements.optionalSupplementsObject[i].reqOpcional.rateSupplementTaxesResponseList[j].taxAmount
 this.totalTaxesDetail += this.$store.getters.getOptionalSupplements.optionalSupplementsObject[i].reqOpcional.rateSupplementTaxesResponseList[j].taxAmount
}
}
this.ls.set("totalSupplements", this.totalStayWithOptionalSupplements - this.totalTaxesDetail)
this.ls.set("totalSupplementsTax",  this.totalTaxesDetail)
             this.ls.set('moreStayingTaxes',  this.totalStayWithOptionalSupplements)
this.dataInfoReserva.totalRateWithTaxes += (this.totalStayWithOptionalSupplements * this.plusDeChambres)
this.supplemnFinal = this.dataInfoReserva.totalRateWithTaxes
this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTotalRateWithTaxes = this.totalStayWithOptionalSupplements
}
            },
    },
    methods: {
      verDetalle(){
        this.banDetCost = true;
        setTimeout(() => {
            this.$bvModal.show('detalleDeCosto1');
        }, 1);
      },
         verDetalleR(){
                this.componentKey += 1;
                this.banDetCost = true;
                    this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTaxes = this.totalTaxesDetail;
                    this.ls.set('moreStayingTaxesMinor',this.totalTaxesDetail);
                    this.ls.set('updateCostDetail', this.infoCosto );
                setTimeout(() => {
                    this.$bvModal.show('detalleDeCosto1');
                }, 20);
            },
    },

  };

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '../../assets/scss/integration/style.scss';
  .contenedorAside {
    display: inline;
  }
  .cardInfoRegistro {
    position: fixed;
    max-width: 290px;
}
.tituloInfo {
    font-size: 15px;
    font-weight: bold;
}
.parrafoInfo {
    font-size: 14px;
    font-weight: 500;
}
.infoHabitacion {
    font-size: 14px;
    font-weight: normal;
}
.icon-info {
  color: #0c5458 !important;
  font-size: 18px !important;
}
.demo-icon {
    font-size: 18px;
}
.moneda {
    font-size: 12px;
    font-weight: 500;
}
.enlaceDetalle {
    font-size: 14px;
    font-weight: 500;
    color: #005a83;
}
.costosTable{
    width: 50%;
    display: inline-block;
    padding-bottom: 10px;
}
.icon-Cerrar {
  font-size: 24px;
  color: #005a83;
}    
  
.infoTotal {
  font-size: 18px;
  font-weight: bold;
}
.infoTotalPrecio {
  font-size: 20px;
  font-weight: bold;
}
.infoTotalMoneda {
  font-size: 13px;
  font-weight: 500;
}
@media only screen and (max-width: 992px){
    .costosTable{
        width: 100%;
        display: inline-block;
    }
}
  .section-full {
    position: fixed;
    width: 100%;
    height: 100%;
    background: #fff;
    top: 0;
    right: -100%;
    z-index: 10;
    transition: all .3s !important;
    overflow: hidden;
  }
  .section-full__header {
    background: white;
    padding: 17.5px 50px;
    position: relative;
    border-bottom: 1px solid #e7e8e9;
    button {
      width: 50px;
      height: 56px;
      background: transparent;
      color: #005a83;
      border: none;
      position: absolute;
      left: 0;
      top: 0;
      padding: 0;
      border-right: solid 1px rgba(255, 255, 255, 0.2);
      span {
        font-size: 24px;
      }
      &:focus {
        outline: none;
      }
    }
    h4 {
      margin: 0;
      font-size: 17px;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.24;
      letter-spacing: 0.43px;
    }
  }
  .section-full__body {
    height: calc(100% - 165px);
    padding-bottom: 58px;
    overflow: auto;
  }
  .section-full__footer {
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 15px;
    width: 100%;
    button {
      &:first-child {
        margin-bottom: 15px;
      }
    }
  }
  .section-full--open {
    right: 0;
    transition: all .3s !important;
  }
  // ESTILOS PARA LA POSICION TOP
  .PC-sidebarTop {
    width: 100%;
    background: #fff;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1), 0 5px 10px 2px rgba(0, 0, 0, 0.2);
    position: fixed;
    top: 55px;
    margin-top: 0;
    z-index: 1;
    height: auto;
    padding: 17px 20px 17px 20px !important;
    text-align: right;
    .contenidoAside {
      margin: 0 auto;
      .col-11 {
        padding-left: 0;
        .col-6 {
          padding-left: 0;
        }
      }
    }
    form {
      padding-right: 40px;
    }
    .form-element {
      text-align: left;
      display: inline-block;
      vertical-align: top;
      width: 33.3333%;
      padding: 0 12px;
      margin-bottom: 10px;
      label {
        margin-bottom: 0;
      }
    }
    .form-element {
      margin-top: 5px;
    }
    .form-element:first-child {
      margin-top: 5px;
    }
    .SidebarTop-info {
      padding: 0;
      margin: 0;
      list-style: none;
      &:after {
        content: '';
        display: table;
        clear: both;
      }
      li {
        float: left;
        vertical-align: middle;
        width: 100%;
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
  
    }
    .SidebarTop-toggleButton {
      background: transparent;
      color: $colorBase2;
      padding: 0;
      width: initial;
      height: initial;
      position: absolute;
      right: 15px;
      bottom: -5px;
      &:focus {
        outline: none;
      }
      span {
        font-size: $font-size-biglarge;
      }
      &--open {
        bottom: 5px;
      }
    }
  }
  @media only screen and (max-width: 992px) {
    .PC-sidebarTop {
      padding: 11px 0 16px 0;
      text-align: left;
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
      .form-element {
        text-align: left;
        display: inline-block;
        vertical-align: top;
        width: 33.3333%;
        padding: 0 12px;
        margin-bottom: 0px;
      }
      form {
        padding-right: 0;
        .form-element:nth-child(1),
        .form-element:nth-child(2) {
          width: 100%;
        }
        .form-element:nth-child(3),
        .form-element:nth-child(4) {
          width: 50%;
        }
        .form-element:nth-child(5) {
          width: 100%;
        }
        .form-element:nth-child(6) {
          width: 100%;
        }
        .form-element:nth-child(7) {
          width: calc(100% - 40px);
        }
      }
      .SidebarTop-info {
        li:nth-child(2) {
          width: 35%;
        }
        li:nth-child(3) {
          width: 60%;
        }
        li:nth-child(4),
        li:nth-child(5),
        li:nth-child(6),
        li:nth-child(7) {
          display: none;
        }
      }
    }
  }
</style>
